<mat-table [dataSource]="dataList" matSort [matSortDisableClear]="true" (matSortChange)="onSortChanged($event)">

  <!-- MeasureDateTime Column -->
  <ng-container matColumnDef="measureDateTime">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@DateOfMeasure"> Measure Date </mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="Measure Date" i18n-data-label="@@DateOfMeasure">
      {{ row.measureDateTime }}
    </mat-cell>
  </ng-container>

  <!-- Weight Column -->
  <ng-container matColumnDef="weight">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@Weight"> Weight </mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="Weight" i18n-data-label="@@Weight">
      {{ weight(row.weight) }}
    </mat-cell>
  </ng-container>

  <!-- Body Fat Column -->
  <ng-container matColumnDef="bodyFat">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@BodyFatPercent"> Body Fat % </mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="Body Fat %" i18n-data-label="@@BodyFatPercent">
      {{ row.bodyFat }}
    </mat-cell>
  </ng-container>

  <!-- BMI Column -->
  <ng-container matColumnDef="bmi">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@BMI"> BMI </mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="BMI" i18n-data-label="@@BMI">
      {{ row.bmi }}
    </mat-cell>
  </ng-container>

  <!-- Source Column -->
  <ng-container matColumnDef="source">
    <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@Source"> Source </mat-header-cell>
    <mat-cell *matCellDef="let row" data-label="Source" i18n-data-label="@@Source">
      {{ row.source }}
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<mat-paginator #paginator [length]="totalCount" [pageSize]="10" (page)="loadDataList(true)"
  [class.hidden]="totalCount === 0">
</mat-paginator>

<div *ngIf="totalCount === 0" class="text-center p-4 border">
  No data found
</div>
